export default __webpack_public_path__ + "static/media/ultra-regular-webfont.1a066519.woff2";